"use strict";

exports.__esModule = true;
exports.UtilizationChartElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _MaxBinLimitWrapper = require("../common/MaxBinLimitWrapper");
var _TooltipSortSelect = require("../common/TooltipSortSelect");
var _tooltipSort = require("../common/tooltipSort");
var _stateDetails = require("./stateDetails");
var _UtilizationSummaryChart = require("./SummaryChart/UtilizationSummaryChart");
var _UtilizationAggregatedChart = require("./UtilizationAggregatedChart");
var _useUiDesign2 = require("../../Theme/UiDesign/useUiDesign");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ErrorText = _styledComponents["default"].div.withConfig({
  displayName: "UtilizationChartElement__ErrorText",
  componentId: "sc-zglf4m-0"
})(["display:flex;height:", "px;width:", "px;justify-content:center;align-items:center;font-size:17px;font-weight:500;"], function (props) {
  return props.height;
}, function (props) {
  return props.width;
});
var MetricLabelWrapper = _styledComponents["default"].div.withConfig({
  displayName: "UtilizationChartElement__MetricLabelWrapper",
  componentId: "sc-zglf4m-1"
})(["display:flex;justify-content:center;align-items:center;z-index:1;margin-bottom:10px;position:relative;"]);
var SortSelectWrapper = _styledComponents["default"].div.withConfig({
  displayName: "UtilizationChartElement__SortSelectWrapper",
  componentId: "sc-zglf4m-2"
})(["position:absolute;left:0;"]);
var FlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "UtilizationChartElement__FlexContainer",
  componentId: "sc-zglf4m-3"
})(["display:flex;justify-content:space-between;flex-direction:row;"]);
var MetricLabel = _styledComponents["default"].h3.withConfig({
  displayName: "UtilizationChartElement__MetricLabel",
  componentId: "sc-zglf4m-4"
})(["margin:0;height:30px;display:flex;align-items:center;"]);
var UtilizationChartElement = exports.UtilizationChartElement = function UtilizationChartElement(props) {
  var width = props.width,
    height = props.height,
    aggregations = props.aggregations,
    _props$tooltipSort = props.tooltipSort,
    tooltipSortProp = _props$tooltipSort === void 0 ? _tooltipSort.TOOLTIP_SORT_DESC : _props$tooltipSort;

  // Under the modern UI the card carries the title; only the sort control
  // stays, left-aligned.
  var _useUiDesign = (0, _useUiDesign2.useUiDesign)(),
    modern = _useUiDesign.modern;
  var metricLabelHeight = 40;
  var summaryChartWidth = 180;
  var allStates = _stateDetails.stateDetails.map(function (state) {
    return state.key;
  });
  var _useState = (0, _react.useState)(allStates),
    selectedStates = _useState[0],
    setSelectedStates = _useState[1];
  var _useState2 = (0, _react.useState)(tooltipSortProp),
    tooltipSort = _useState2[0],
    setTooltipSort = _useState2[1];
  (0, _react.useEffect)(function () {
    setTooltipSort(tooltipSortProp || _tooltipSort.TOOLTIP_SORT_DESC);
  }, [tooltipSortProp]);
  var timeAggregationName = (0, _timeAggregationBinMapping.getTimeGroupingNameFromAgg)({
    aggregations: aggregations
  });
  var isTimeAggregated = !!timeAggregationName;
  if (!isTimeAggregated) {
    return /*#__PURE__*/_react["default"].createElement(ErrorText, {
      width: width,
      height: height
    }, "Please select a time aggregation");
  }
  return /*#__PURE__*/_react["default"].createElement(_MaxBinLimitWrapper.MaxBinLimitWrapper, {
    timeAggregationName: timeAggregationName
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "UtilizationChart",
    style: {
      display: "flex",
      flexDirection: "column",
      height: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement(MetricLabelWrapper, {
    style: modern ? {
      justifyContent: "flex-start"
    } : undefined
  }, modern ? /*#__PURE__*/_react["default"].createElement(_TooltipSortSelect.TooltipSortSelect, {
    tooltipSort: tooltipSort,
    onTooltipSortChange: setTooltipSort,
    dataTestId: "UtilizationChart.TooltipSort"
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(SortSelectWrapper, null, /*#__PURE__*/_react["default"].createElement(_TooltipSortSelect.TooltipSortSelect, {
    tooltipSort: tooltipSort,
    onTooltipSortChange: setTooltipSort,
    dataTestId: "UtilizationChart.TooltipSort"
  })), /*#__PURE__*/_react["default"].createElement(MetricLabel, null, "Utilization"))), /*#__PURE__*/_react["default"].createElement(FlexContainer, null, /*#__PURE__*/_react["default"].createElement(_UtilizationSummaryChart.UtilizationSummaryChart, _extends({}, props, {
    width: summaryChartWidth,
    height: height - metricLabelHeight,
    selectedStates: selectedStates,
    tooltipSort: tooltipSort
  })), /*#__PURE__*/_react["default"].createElement(_UtilizationAggregatedChart.UtilizationAggregatedChart, _extends({}, props, {
    width: width - summaryChartWidth,
    height: height - metricLabelHeight,
    selectedStates: selectedStates,
    setSelectedStates: setSelectedStates,
    tooltipSort: tooltipSort
  })))));
};